import Vue from 'vue';

const showData = new Vue({
    data(){
        return{
            showData:false
        }
    }
});

export default showData


// WEBPACK FOOTER //
// ./src/router/sdata.js